export type ExploreComposerMode = 'image' | 'video';

export const EXPLORE_COMPOSER_OPEN_EVENT = 'dobidobi:open-explore-composer';
const EXPLORE_COMPOSER_MODE_STORAGE_KEY = 'dobidobi:pending-explore-composer-mode';

export function requestExploreComposerOpen(mode: ExploreComposerMode, direct = false): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(EXPLORE_COMPOSER_MODE_STORAGE_KEY, direct ? `${mode}:direct` : mode);
  window.dispatchEvent(new CustomEvent(EXPLORE_COMPOSER_OPEN_EVENT, { detail: { mode, direct } }));
}

export function consumeExploreComposerRequest(): { mode: ExploreComposerMode; direct: boolean } | null {
  if (typeof window === 'undefined') return null;
  const value = window.sessionStorage.getItem(EXPLORE_COMPOSER_MODE_STORAGE_KEY);
  if (!['image', 'video', 'image:direct', 'video:direct'].includes(value ?? '')) return null;
  window.sessionStorage.removeItem(EXPLORE_COMPOSER_MODE_STORAGE_KEY);
  return { mode: value!.startsWith('image') ? 'image' : 'video', direct: value!.endsWith(':direct') };
}

export function consumeExploreComposerMode(): ExploreComposerMode | null {
  return consumeExploreComposerRequest()?.mode ?? null;
}
